import axios from 'axios';
import moment from 'moment';
import {
  DETAIL_PROMO,
  INTERSECTION_ITEM_AND_CATEGORY,
  INTERSECTION_ITEM_VARIANTS,
  PROMO_TYPES,
  V1_PROMO_BUY_X_GET_Y,
  V1_PROMO_BUY_X_GET_Y_WITH_OUTLETS,
} from './constants';

export function getAllPromoTypes() {
  return axios.get(PROMO_TYPES, {});
}

export function getIntersectedItemAndCategories(outletIds) {
  const request = {
    outlet_ids: !outletIds ? null : outletIds,
  };
  return axios.post(INTERSECTION_ITEM_AND_CATEGORY, request, {
    params: { outlet_id: outletIds[0] },
    withCredentials: true,
  });
}

export function getIntersectedItemVariants(itemName, outletIds) {
  const request = {
    item_name: itemName,
    outlet_ids: outletIds,
  };
  return axios.post(INTERSECTION_ITEM_VARIANTS, request, {
    params: { outlet_id: outletIds[0] },
    withCredentials: true,
  });
}

export function onCreateNewPromoBuyXGetY(requestBody) {
  const headers = {
    time: moment().toISOString(),
  };
  return axios
    .post(V1_PROMO_BUY_X_GET_Y, requestBody, { headers })
    .catch(error => {
      const { response } = error;
      return Promise.reject(response);
    });
}

export function getPromoList(params) {
  params.current_time = moment().toISOString();
  return axios.get(V1_PROMO_BUY_X_GET_Y_WITH_OUTLETS, {
    params,
  });
}

export function getDetailPromo(promoId) {
  return axios.get(DETAIL_PROMO(promoId), {});
}

export function deletePromo(promoId) {
  const headers = {
    time: moment().toISOString(),
  };
  return axios.delete(DETAIL_PROMO(promoId), { headers });
}

export function updatePromo(promoId, data) {
  const headers = {
    time: moment().toISOString(),
  };
  return axios.put(DETAIL_PROMO(promoId), data, { headers });
}
